import React, { Component, Fragment } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class Datatable extends Component {
  render() {
    const { myData } = this.props;
    const rows = myData || [];

    return (
      <Fragment>
        <div className="bp-table-wrap">
          <table className="table bp-table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Date</th>
                <th scope="col">Note</th>
                <th scope="col">Amount</th>
                <th scope="col" className="bp-col-action">Receipt</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={5} className="bp-empty">
                    No entries for this month.
                  </td>
                </tr>
              ) : (
                rows.map((expense, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{expense.date}</td>
                    <td>{expense.note}</td>
                    <td>
                      <span className="bp-amount-pill">{expense.amount}Tk</span>
                    </td>
                    <td className="bp-col-action">
                      {expense.imageUrl && (
                        <a href={expense.imageUrl} target="_blank" rel="noreferrer">
                          <img
                            src={expense.imageUrl}
                            className="bp-receipt-thumb"
                            alt="Receipt"
                          />
                        </a>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Datatable;
